import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { TimeLabel } from '../components/TimeLabel';

export const PublicationDateContainer: FC = () => {
  const { updatedAt, updatedOn } = useCardOfferDataContext();

  return <TimeLabel added={updatedAt} humanizedTime={updatedOn} />;
};
